import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-admin';
import Menu from '@material-ui/core/Menu';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { translate as translateComponent } from 'react-admin';

const CleanerMenuActions = ({
  children,
  className,
  label,
  placeholder,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button className={className} variant="contained" onClick={handleClick}>
        <div
          style={{
            fontSize: '0.8125rem',
            fontWeight: 500,
            fontFamily: 'Roboto',
          }}
        >
          <LibraryBooksIcon style={{ fontSize: 0 }} /> {placeholder}
        </div>
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {React.Children.map(children, (child) => {
          if (child) {
            return React.cloneElement(child, {
              ...props,
            });
          }
          return null;
        })}
      </Menu>
    </div>
  );
};

CleanerMenuActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  translate: PropTypes.func,
};

CleanerMenuActions.defaultProps = {
  children: {},
  className: undefined,
  label: '',
  placeholder: '',
  translate: /* istanbul ignore next */ () => {},
};

export default translateComponent(CleanerMenuActions);
